export default __webpack_public_path__ + "static/media/srfb1.47262871.jpeg";